type FooterItem = {
  title: string;
  url: string;
  isExternal?: boolean;
  /** Set on a link that leads to an intake form, so a click is credited to it */
  formSlug?: string;
};

type FooterSection = {
  title: string;
  links: FooterItem[];
};

export const platformFooterItems: FooterSection[] = [
  {
    title: "Pollinator Program",
    links: [
      {
        title: "Overview",
        // The program's own section, which is what the heading above it
        // promises, not the top of the homepage.
        url: "/#program",
      },
      {
        title: "Support",
        url: "/support",
      },
    ],
  },
  {
    title: "Team",
    links: [
      {
        title: "About us",
        // The section's anchor rather than its address, so it scrolls there
        // as the header's links do instead of landing as a new page would.
        url: "/#team",
      },
      {
        title: "Contact",
        url: "/contact",
        formSlug: "contact",
      },
    ],
  },
  {
    title: "Social",
    links: [
      {
        title: "Instagram",
        url: "https://instagram.com/pollinator_coop",
        isExternal: true,
      },
      {
        title: "LinkedIn",
        url: "https://www.linkedin.com/company/pollinator-coop",
        isExternal: true,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        title: "Terms",
        url: "/terms",
      },
      {
        title: "Privacy",
        url: "/privacy",
      },
    ],
  },
];

export default platformFooterItems;
